module.exports = __webpack_public_path__ + "static/media/fal_fal_pal_bal_sec.c0bfec3f.png";